import { render, staticRenderFns } from "./CallCenterSidebar.vue?vue&type=template&id=4da80743&scoped=true&"
import script from "./CallCenterSidebar.vue?vue&type=script&lang=ts&"
export * from "./CallCenterSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./CallCenterSidebar.vue?vue&type=style&index=0&id=4da80743&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da80743",
  null
  
)

export default component.exports